var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.103 7.2227L16.81 13.9207C16.8751 13.9862 16.9527 14.0379 17.0382 14.0728C17.1236 14.1077 17.2152 14.1251 17.3075 14.124C17.3999 14.1229 17.491 14.1033 17.5756 14.0663C17.6602 14.0293 17.7365 13.9757 17.8 13.9087C17.9301 13.7716 18.0016 13.5892 17.9994 13.4003C17.9972 13.2113 17.9213 13.0306 17.788 12.8967L10.585 5.7037C10.5204 5.63863 10.4434 5.5871 10.3586 5.55211C10.2739 5.51713 10.183 5.4994 10.0912 5.49996C9.99953 5.50052 9.90885 5.51936 9.8245 5.55537C9.74016 5.59138 9.66383 5.64385 9.6 5.7097L2.205 13.2807C2.07412 13.4162 2.00098 13.5973 2.00098 13.7857C2.00098 13.9741 2.07412 14.1552 2.205 14.2907C2.26931 14.3569 2.34626 14.4096 2.43129 14.4455C2.51631 14.4815 2.60769 14.5 2.7 14.5C2.79231 14.5 2.88369 14.4815 2.96872 14.4455C3.05374 14.4096 3.13069 14.3569 3.195 14.2907L10.103 7.2227Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpAccordion);
export default __webpack_public_path__ + "static/media/up-accordion.b037a28a10bca397cf18a27e98c39246.svg";
export { ForwardRef as ReactComponent };